(function () {
  if (window.__damieFreteDesktop) return
  window.__damieFreteDesktop = true
  function init() {
    document.querySelectorAll('.m2dp-wrap,.m2db-wrap,.damie-linha-1').forEach(function (root) {
      if (root.dataset.freteDesktop) return
      var freight = root.querySelector('damie-frete-produto')
      var section = root.closest('.shopify-section')
      var next = section && section.nextElementSibling
      var benefits = next && next.querySelector('.damie-beneficios')
      if (!freight || !benefits) return
      root.dataset.freteDesktop = 'true'
      freight.id = root.id + '-frete'
      var freightHome = document.createComment('Local do frete no celular')
      var benefitsHome = document.createComment('Local dos benefícios no celular')
      freight.before(freightHome)
      benefits.before(benefitsHome)
      var row = document.createElement('div')
      row.className = 'damie-desktop-beneficios-frete'
      var left = document.createElement('div')
      left.className = 'damie-desktop-beneficios'
      var right = document.createElement('div')
      right.className = 'damie-desktop-frete'
      row.append(left, right)
      root.after(row)
      var media = window.matchMedia('(min-width:750px)')
      function arrange() {
        if (media.matches) {
          left.append(benefits)
          right.append(freight)
          next.classList.add('damie-beneficios-deslocados')
          row.hidden = false
          root.style.setProperty('--damie-frete-height', '180px')
        } else {
          benefitsHome.after(benefits)
          freightHome.after(freight)
          next.classList.remove('damie-beneficios-deslocados')
          row.hidden = true
        }
      }
      media.addEventListener('change', arrange)
      arrange()
    })
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init)
  else init()
})()
